import { Component, OnDestroy, OnInit } from '@angular/core';
import { HomeComponent } from '../home/home.component';
import { ProductService } from '../../service/ProductService';
import { ASStandardOringSizesService } from '../../service/ASStandardOringSizesService';
import { SavedFilesApi } from './saved-files.api';
import { FormService } from '../../service/FormService';
import { MatDialog } from '@angular/material';
import { FileDeleteComponent } from './file-delete/file-delete.component';
import { TooltipsService } from '../../service/tooltips.service';
import { DataToSaveService } from '../../service/data-to-save.service';
import { NotificationsService } from '../../service/notifications.service'
import {DialogState, ScrollBarData} from "../shared/scroll-bar-data";
import {Config} from "../../config";

@Component({
  selector: 'app-saved-files',
  templateUrl: './saved-files.component.html',
  styleUrls: ['./saved-files.component.css'],
  providers: [HomeComponent, ProductService, ASStandardOringSizesService, FormService, TooltipsService, NotificationsService]
})
export class SavedFilesComponent implements OnDestroy, OnInit {

  files = [];
  totalCount: number;
  pageCount: number;
  filesPerPage = 10;
  pages = [];
  currentPage = 1;
  fileIndex: number;

  constructor(private dialog: MatDialog, private savedFilesApi: SavedFilesApi, private dataToSaveService: DataToSaveService) {
    document.body.classList.add('savedList');
  }

  ngOnInit() {
    this.dataToSaveService.setPath('saved-files');
    this.fetchData();
    this.savedFilesApi.confirmDelete.subscribe(() => {
      this.deleteFile(this.fileIndex);
    });
  }

  ngOnDestroy() {
    document.body.classList.remove('savedList');
  }

  fetchData(page = 1, direction?: string) {
    if ((this.currentPage === this.pages.length && direction === 'next') || (this.pages.length <= 1 && direction === 'next')) return;
    if (this.currentPage === 1 && direction === 'prev') return;
      this.savedFilesApi.getFiles(page).subscribe(res => {
        this.files = res.results;
        this.paginate(res.count);
        this.currentPage = page;
      });
  }

  openDeleteModal(index) {
    this.fileIndex = index;
    const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
    const matDialogRef = this.dialog.open(FileDeleteComponent);
    ScrollBarData.updateBodyWidth(DialogState.OPEN, hasScrollbar);
    matDialogRef.afterClosed().subscribe(() => ScrollBarData.updateBodyWidth(DialogState.CLOSE));
  }

  deleteFile(index) {
    this.dialog.closeAll();
    if (!this.files[this.fileIndex]) return;
    this.savedFilesApi.delete(this.files[this.fileIndex].id)
      .subscribe((res) => {
        this.fileIndex = NaN;
        this.updateContent();
      },
      (err) => {
        if (err.status === 404) {
          this.updateContent();
        }
      });
  }

  downloadFile(index: number) {
    const url =  Config.BASE_URL + 'users/saved-files/';
    window.open(url + this.files[index].id + '/', '_self');
  }

  paginate(totalcount: number) {
    this.totalCount = totalcount;
    this.pageCount = Math.ceil(totalcount / this.filesPerPage);
    this.pages = new Array(this.pageCount);
  }

  viewFile(index) {
    const url =  Config.BASE_URL + 'users/saved-files/' + this.files[index].id + '/';
    window.open('https://docs.google.com/viewer?url=' + url, '_blank');
  }

  updateContent() {
    if (this.currentPage === 1 || this.currentPage !== this.pageCount) {
      setTimeout(() => {
        this.fetchData(this.currentPage);
      });
    }
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/saved-files/saved-files.component.ts